import _ from 'lodash';
import { buildUrl, denormalizeUrl } from '../../libs/utils';

import {
	PublicClientApplication,
	InteractionRequiredAuthError
} from '@azure/msal-browser';

export default class AzureAD {
	account: any;
	options: any;
	manager: any;

	constructor(options = {}) {
		this.account = null;

		this.options = _.merge(
			{
				client: null,
				authority: null,

				notificationElementClassName: 'app',

				logger: null,

				azure: {}
			},
			options
		);

		this.options.azure = _.merge(
			{
				auth: {
					clientId: this.options.client,
					authority: this.options.authority,

					redirectUri: denormalizeUrl(this.root).toLowerCase(),
					postLogoutRedirectUri: denormalizeUrl(
						this.root
					).toLowerCase()
				},
				cache: {
					cacheLocation: 'sessionStorage', // This configures where your cache will be stored
					storeAuthStateInCookie: false
				}
			},
			this.options.azure
		);
	}

	get isLoggedIn() {
		return !!this.account;
	}

	get loginParameters() {
		return {
			scopes: [
				'openid',
				'profile',
				buildUrl(this.host, 'user_impersonation')
			]
		};
	}

	get tokenParameters() {
		return {
			...this.loginParameters,
			account: this.account
		};
	}

	get host() {
		return [window.location.protocol, window.location.host].join('//');
	}

	get root() {
		return [
			window.location.protocol,
			[
				window.location.host,
				window.location.pathname.substr(
					1,
					window.location.pathname.lastIndexOf('/')
				)
			]
				.filter(Boolean)
				.join('/')
		].join('//');
	}

	init() {
		this.manager = new PublicClientApplication(this.options.azure);

		return this.manager
			.handleRedirectPromise()
			.then((tokenResponse: any) => {
				this.authenticate(tokenResponse);

				if (!this.isLoggedIn) {
					return this.login();
				}
			})
			.catch((e: any) => this.notify(e));
	}

	authenticate(tokenResponse: any) {
		if (tokenResponse !== null) {
			this.setAccount(tokenResponse.account);
		} else {
			this.selectAccount();
		}
	}

	login() {
		return this.manager?.loginRedirect(this.loginParameters);
	}

	logout() {
		return this.manager?.logout();
	}

	setAccount(account: any) {
		this.account = account;
	}

	selectAccount() {
		const currentAccounts = this.manager?.getAllAccounts();

		if (currentAccounts && currentAccounts.length === 1) {
			// no support for multiple accounts yet
			this.setAccount(currentAccounts[0]);
		}
	}

	getAuthorizationHeader() {
		return this.getToken().then((response: any) =>
			this.buildAuthorizationHeader(response)
		);
	}

	buildAuthorizationHeader(token: any) {
		return {
			Authorization: [token?.tokenType, token?.accessToken]
				.filter(Boolean)
				.join(' ')
		};
	}

	getToken() {
		return this.manager
			.acquireTokenSilent(this.tokenParameters)
			.catch((e: any) => {
				if (e instanceof InteractionRequiredAuthError) {
					// fallback to interaction when silent call fails
					return this.manager.acquireTokenRedirect(
						this.tokenParameters
					);
				} else {
					this.notify(e);
				}
			});
	}

	getAccessToken() {
		return this.getToken().then((token: any) => token?.accessToken);
	}

	notify(e: any) {
		const elm = document.getElementsByClassName(
			this.options.notificationElementClassName
		);

		if (elm.length) {
			elm[0].outerHTML = `<div class="ui-critical-error">${e.message}</div>`;
		}
	}
}
